import { defineStyleConfig } from '@chakra-ui/react';

const Table = defineStyleConfig({
  baseStyle: (props) => ({
    table: {
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    th: {
      fontWeight: '600',
      fontSize: 'sm',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      color: props.colorMode === 'dark' ? 'text.primary' : '#4A5568',
      borderColor: props.colorMode === 'dark' ? 'gray.700' : '#E2E8F0',
      borderBottomWidth: '2px',
      bg: props.colorMode === 'dark' ? 'gray.800' : '#F8FAFC',
      py: '14px',
      px: '16px',
    },
    td: {
      fontSize: 'md',
      borderColor: props.colorMode === 'dark' ? 'gray.700' : '#E2E8F0',
      py: '14px',
      px: '16px',
      color: props.colorMode === 'dark' ? 'text.primary' : '#1A202C',
    },
  }),
  variants: {
    simple: (props) => ({
      tbody: {
        tr: {
          '&:hover': {
            bg: props.colorMode === 'dark' ? 'gray.700' : '#F7FAFC',
          },
          borderBottomWidth: '1px',
          borderBottomColor: props.colorMode === 'dark' ? 'gray.700' : '#E2E8F0',
        }
      },
    }),
    striped: (props) => ({
      tbody: {
        tr: {
          '&:nth-of-type(odd)': {
            bg: props.colorMode === 'dark' ? 'gray.850' : '#FAFBFC',
          },
          '&:hover': {
            bg: props.colorMode === 'dark' ? 'gray.700' : '#EDF2F7',
          }
        }
      },
    })
  },
  defaultProps: {
    variant: 'simple',
  },
});

export default Table;
